import { render, staticRenderFns } from "./PortfolioPage.vue?vue&type=template&id=88e3bd86&scoped=true&"
import script from "./PortfolioPage.vue?vue&type=script&lang=js&"
export * from "./PortfolioPage.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioPage.vue?vue&type=style&index=0&id=88e3bd86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e3bd86",
  null
  
)

export default component.exports